"use client";

import { BadgeCheck, Lock, Pin } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/app/_module/components/ui/tooltip";
import { lpProfileUrl } from "./ForumService";

// "Verified on Licensedproducer" — links out to the agent's PUBLIC directory
// profile. Rendered next to author names everywhere.
export function LpVerifiedBadge({ slug, size = "sm" }: { slug: string; size?: "sm" | "md" }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={lpProfileUrl(slug)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="inline-flex items-center text-primary transition-colors hover:text-primary/80"
            aria-label="Verified on Licensedproducer — view agent profile"
          >
            <BadgeCheck className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
          </a>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          Verified on Licensedproducer — view profile
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

// "Staff" — an InsuraCentral admin posting as the company.
export function StaffBadge() {
  return (
    <span
      title="InsuraCentral staff"
      className="inline-flex items-center rounded-sm border border-primary/30 bg-primary/5 px-1 py-px text-[10px] font-semibold uppercase leading-none tracking-[0.08em] text-primary"
    >
      Staff
    </span>
  );
}

// Status labels are words with a glyph, in ink — not colored pills.
export function PinnedBadge() {
  return (
    <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-foreground/80">
      <Pin className="h-3 w-3" />
      Pinned
    </span>
  );
}

export function LockedBadge() {
  return (
    <span className="inline-flex items-center gap-1 text-[11px] text-muted-foreground">
      <Lock className="h-3 w-3" />
      Locked
    </span>
  );
}

// Category as a label: small caps, accent color, clickable.
export function CategoryChip({
  name,
  onClick,
}: {
  name: string;
  slug?: string | null;
  onClick?: () => void;
}) {
  return (
    <span
      onClick={(e) => {
        if (!onClick) return;
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={`text-[11px] font-semibold uppercase tracking-[0.08em] text-primary ${onClick ? "cursor-pointer hover:underline" : ""}`}
    >
      {name}
    </span>
  );
}
